module.exports = __webpack_public_path__ + "static/img/wakabayashi.84356cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/players/wakabayashi.png
// module id = /oWf
// module chunks = 0